import React, { FunctionComponent, useState, useRef, useEffect } from 'react';
import {
  Button,
  Col,
  Form,
  FormControl,
  Modal,
  Row,
  Table,
} from 'react-bootstrap';
import { connect, ConnectedProps } from 'react-redux';
import apis from '../../apis';
import { AuthedLayout } from '../../components';
import { Student, TransferInfo } from '../../model';
import { ErrorDispatches } from '../../redux/Dispatches';
import { ApplicationState } from '../../redux/States';
import { useHistory } from 'react-router';
import { useClassGrade, useClassStudents } from '../../hook';

const mapState = (state: ApplicationState) => ({
  ...state.auth,
});
const mapDispatch = { ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);

type Props = ConnectedProps<typeof connector>;

const transferOutPage: FunctionComponent<Props> = ({
  user,
  loading,
  catchErrorForModal,
}) => {
  const [student, setStudent] = useState<Student>();
  const [transferInfo, setTransfrInfo] = useState<TransferInfo>();
  const [modalContent, setModalContent] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const [studentPid, setStudentPid] = useState<string>();
  const ref = useRef<HTMLInputElement>(null);
  const testRef = useRef<HTMLInputElement>(null);
  const yearSem = user.semesters[user.currentSemester];
  const { selectedClassGrade, element: classGradeButton } = useClassGrade({
    yearSem,
    disableQueryParamStore: true,
  });
  const { selectedStudent, element: studentButton } = useClassStudents({
    yearSem,
    classId: selectedClassGrade?.id,

  });

   useEffect(() => {
    if (selectedStudent) {
      setStudentPid(selectedStudent.pid);
      apis
        .GetStudent(selectedStudent.pid)
        .then((s) => {
          setStudent(s);
          apis
            .getTransferOutInfo(s.pid)
            .then((t) => setTransfrInfo(t))
            .catch(() => setTransfrInfo(undefined));
        })
        .catch((e) => {
          setTransfrInfo(undefined);
          setStudent(undefined);
          catchErrorForModal(e);
        });
    }

  }, [selectedStudent]);

  if (loading) {
    useHistory().go(0);
    return <></>;
  }

  const button =
    !transferInfo && student ? (
      <>
        <Col xs={1} className="mr-2">
          <Button
            disabled={isLoading}
            onClick={() => {
              setIsLoading(true);
              apis
                .transferOutToShis(student.pid)
                .then(() => {
                  setTransfrInfo(undefined);
                  setStudent(undefined);
                  setModalContent('轉出成功');
                  setIsLoading(false);
                })
                .catch(catchErrorForModal);
            }}
          >
            轉出
          </Button>
        </Col>
      </>
    ) : (
      <></>
    );

  const studentContent = student ? (
    <>
      <Table bordered className="student-phi">
        <tbody>
          <tr>
            <th>身份證</th>
            <td>{student.pid}</td>
          </tr>
          <tr>
            <th>座號</th>
            <td>{student.seat}</td>
          </tr>
          <tr>
            <th>學生</th>
            <td>{student.name}</td>
          </tr>
          <tr>
            <th>學號</th>
            <td>{student.sid}</td>
          </tr>
          <tr>
            <th>性別</th>
            <td>{student.sex}</td>
          </tr>
          <tr>
            <th>生日</th>
            <td>{student.birth?.toFormat('yyyy/MM/dd')}</td>
          </tr>
          <tr>
            <th>父親</th>
            <td>{student.dad}</td>
          </tr>
          <tr>
            <th>母親</th>
            <td>{student.mom}</td>
          </tr>
          <tr>
            <th>連絡電話</th>
            <td>{student.tel}</td>
          </tr>
          <tr>
            <th>緊急連絡</th>
            <td>{student.erTel}</td>
          </tr>
          <tr>
            <th>身份</th>
            <td>{student.aborigine}</td>
          </tr>
        </tbody>
      </Table>
    </>
  ) : (
    <></>
  );

  return (
    <AuthedLayout>
      <Row className="mb-2">
        {/* 學生身份證：
        <Col xs={2} className="mr-2">
          <FormControl ref={ref} />
        </Col> */}
        <div className="wid-130 mr-2">{classGradeButton}</div>
        <div className="mr-2">{studentButton}</div>
        {/* <Col xs={1} className="mr-2">
          <Button
            onClick={() => {
              if (ref.current && ref.current?.value.length > 5)
                apis
                  .GetStudent(ref.current?.value)
                  .then((s) => {
                    setStudent(s);
                    apis
                      .getTransferOutInfo(s.pid)
                      .then((t) => setTransfrInfo(t))
                      .catch(() => setTransfrInfo(undefined));
                  })
                  .catch((e) => {
                    setTransfrInfo(undefined);
                    setStudent(undefined);
                    catchErrorForModal(e);
                  });
            }}
          >
            搜尋
          </Button>
        </Col> */}
        {button}
      </Row>
      <hr />
      {transferInfo && transferInfo.schoolId === user.currentSchool ? (
        <>
          <Row className="mb-2">
            <b className="text-danger">已設定學生轉出</b>
          </Row>
        </>
      ) : (
        <></>
      )}
      <Row className="mb-2">
        <Col>{studentContent}</Col>
      </Row>
      {/* TODO刪除 */}
      {user.name == 'SHIS測試帳號' ? (
        <>
          <h4>--------(僅限測試帳號 老師看不到)新轉舊 上傳資料至中央端--------</h4>
          <Col xs={6} className="mr-2">
            <FormControl ref={testRef} />
          </Col>
          <Col xs={6}>
            <Button
              onClick={() => {
                if (testRef.current && testRef.current?.value)
                  apis
                    .transferOutTest(testRef.current?.value)
                    .then(() => {
                      // setModalContent('轉出成功');
                    })
                    .catch(catchErrorForModal);
              }}
            >
              轉出api
            </Button>
          </Col>
        </>
      ) : (
        <></>
      )}

      <Modal
        show={!!modalContent}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setStudent(undefined);
            setTransfrInfo(undefined);
            setModalContent(undefined);
            window.location.href = '/transfer/out';
          }}
        >
          <Modal.Title id="contained-modal-title-vcenter">
            轉學生 - 轉出
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">{modalContent}</Modal.Body>

        <Modal.Footer></Modal.Footer>
      </Modal>
    </AuthedLayout>
  );
};

export const TransferOutPage = connector(transferOutPage);
